type PermissionAction = 'index' | 'show' | 'store' | 'update' | 'destroy';
const PERMISSION_ACTIONS: PermissionAction[] = ['index', 'show', 'store', 'update', 'destroy'];

export { PERMISSION_ACTIONS, PermissionAction };